import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-maintenance-mode',
  templateUrl: './maintenance-mode.component.html',
  styleUrls: ['./maintenance-mode.component.css']
})
export class MaintenanceModeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
